export const LADE_MAHNSTUFEN_WERTE = "ladeMahnstufenWerte";

